export default "__VITE_ASSET__9EJX6j3b__"